<template>
  <div>
    <vue-editor
      v-if="showTool"
      :editorToolbar="customToolbar"
      useCustomImageHandler
      @image-added="handleImageAdded"
      v-model="value"
      class="editStyle"
    >
    </vue-editor>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import { uploadFile } from "@/api/formList";
export default {
  props: ["data", "config"],
  components: { VueEditor },
  data() {
    return {
      showTool: false,
      customToolbar: [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { background: [] },
        { color: [] },
      ],
    };
  },
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  mounted() {
    this.customToolbar = this.customToolbar.concat(
      this.config.rules.richConfig.customToolbar
    );
    this.showTool = true;
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("fileType", 2);
      uploadFile(formData).then((res) => {
        if (res) {
          const url = res.data.url; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        }
      });
    },
  },
};
</script>
<style lang="stylus">
.editStyle
  .ql-editor
    max-height: 200px
</style>
